import { useContext } from 'react'
import { SessionContext } from '../../contexts/auth/SessionContext'

const useSessionContext = () => {
  const data = useContext(SessionContext)
  return data
}

export default useSessionContext
